import React from 'react';
import { connect } from 'react-redux';
import { openPanelModal } from '../store/actions';
import styles from '../Dashboards.mod.less';
import renderIf from 'render-if';
import terminology from 'javascripts/terminology';

const ProgressEmpty = ({
  width = 'initial',
  height = 'auto',
  padding,
  panel,
  publishing,
  canEdit,
  openPanelModal,
}) => {
  const paddingStr = `${padding[0]}px ${padding[1]}px`;

  return (
    <div style={{ height, width, padding: paddingStr }}>
      <div className={'dashboard-panel--empty'}>
        <p className={styles.ReleaseProgressEmpty}>
          {renderIf(panel.releasePermission)(() => (
            <span>
              No {`${terminology('release')}`} has been selected for this panel.
            </span>
          ))}
          {renderIf(!panel.releasePermission)(() => (
            <span>
              The {`${terminology('release')}`} in this panel is in a workspace
              that you do not have access to view
            </span>
          ))}

          {renderIf(canEdit && !publishing)(() => (
            <span>
              <a onClick={() => openPanelModal(panel.id)}>Edit the panel</a>{' '}
              settings to select a {`${terminology('release')}`}.
            </span>
          ))}
        </p>
      </div>
    </div>
  );
};

const mapDispatchToProps = { openPanelModal };

export default connect(null, mapDispatchToProps)(ProgressEmpty);
